/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */

import * as React from 'react';
import { connect } from 'react-redux';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { ClippingPlatformState } from '../../store/clippingPlatformState';

interface TabulatedFormOwnProps {
  children: any[];
  handleSelectedFormChange: (formId: string) => void;
}

interface TabulatedFormStateProps {
  formTabs: any[];
}

class TabulatedForm extends React.Component<TabulatedFormOwnProps & TabulatedFormStateProps> {
  private handleTabSelect(tabIndex: number) {
    const children = this.getFormChildren();

    if (tabIndex >= children.length) {
      throw new Error('Invalid tab selected');
    }
    this.props.handleSelectedFormChange(this.props.formTabs[tabIndex].props.form);
  }

  private getFormChildren() {
    return this.props.children.filter(child => child.props);
  }

  public render() {
    const boundHandleTabSelect = this.handleTabSelect.bind(this);

    return (
      // eslint-disable-next-line react/jsx-no-bind
      <Tabs onSelect={boundHandleTabSelect}>
        <TabList>
          {this.props.formTabs.map((form: any, index: number) => {
            return form && form.props && form.props.title && <Tab key={index}>{form.props.title}</Tab>;
          })}
        </TabList>
        {this.props.formTabs.map((form: any, index: number) => {
          return form && <TabPanel key={index}>{form}</TabPanel>;
        })}
      </Tabs>
    );
  }
}

function mapStateToProps(state: ClippingPlatformState, ownProps: TabulatedFormOwnProps): TabulatedFormStateProps {
  return {
    formTabs: ownProps.children.filter(child => child && child.props && child.props.form && child.props.title),
  };
}
export default connect(mapStateToProps)(TabulatedForm);
